import { ConditionalWrapperProps } from "@coxauto-ui/cxm/communications/interfaces";
import { Tooltip } from "@interstate/components/Tooltip";
import { ReactElement } from "react";

export function ConditionalToolTipWrapper({
  condition,
  toolTipContent,
  children
}: ConditionalWrapperProps): ReactElement {
  return condition ? (
    <Tooltip
      data-testid="conditional-tool-tip-wrapper"
      position="bottom"
      size="large"
      toolTipContent={toolTipContent}
    >
      {children}
    </Tooltip>
  ) : (
    children
  );
}
